import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Flex,
  Form,
  Image,
  Modal,
  Rate,
  Row,
  Tag,
  Typography,
  Upload,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GetCardLayout } from "../../../../common/getCardLayout";
import { routes, userRoles } from "../../../../../constants";
import { baseRouteMaker } from "../../../../../constants/routeConsts";
import Actions from "../../../../../redux/actions";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { appAssetsConfig } from "../../../../../constants/config/appAssetsConfig";
import useLocalStorage from "../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../constants/config/appConfig";

const ServiceProviderReviewInfoDetails = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* id dependencies */
  const { selectedServiceProviderReviewInfoDetails } = useSelector(
    (state) => state.reviews
  );
  /* id dependencies */

  /* detail dependencies */
  const [appointmentsInfoDetails, setAppointmentsInfoDetails] = useState(null);
  /* detail dependencies */

  /* module dependencies for attachment */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  const [servicesAttachmentList, setServicesAttachmentList] = useState([]);
  /* module dependencies for attachment */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedServiceProviderReviewInfoDetails &&
      selectedServiceProviderReviewInfoDetails !== "" &&
      selectedServiceProviderReviewInfoDetails !== null &&
      selectedServiceProviderReviewInfoDetails !== undefined &&
      Object.keys(selectedServiceProviderReviewInfoDetails)?.length !== 0
    ) {
      setAppointmentsInfoDetails(selectedServiceProviderReviewInfoDetails);
      setAttachmentList(
        selectedServiceProviderReviewInfoDetails?.documents?.map((element) => ({
          ...element,
          url: element?.url,
        }))
      );
      setServicesAttachmentList(
        selectedServiceProviderReviewInfoDetails?.service_id?.images?.map(
          (element) => ({
            ...element,
            url: element?.url,
          })
        )
      );
    }
  }, []);

  return (
    <div>
      <Flex vertical gap="2rem">
        <GetCardLayout>
          <Flex vertical gap="2rem">
            <Flex gap="1rem">
              <Button
                type="default"
                shape="circle"
                size="small"
                icon={<ArrowLeftOutlined />}
                onClick={() => {
                  navigate(baseRouteMaker(routes.SERVICE_PROVIDER_REVIEWS));
                  dispatch(
                    Actions.createAction(
                      Actions.SELECTED_SERVICE_PROVIDER_REVIEW_INFO_DETAILS,
                      { selectedReviewId: {} }
                    )
                  );
                }}
              />
              <Typography.Title underline level={2}>
                {t("AppModuleNames.SuperAdmin.reviewInfo")}
              </Typography.Title>
            </Flex>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.CustomerName")}
                  required={false}
                />
                <div>
                  {appointmentsInfoDetails?.user
                    ? `${appointmentsInfoDetails?.user?.first_name} ${appointmentsInfoDetails?.user?.last_name}`
                    : "-"}
                </div>
              </Col>
              <Col span={8}>
                <RequiredLabel text={t("CommonUtils.email")} required={false} />
                <div>
                  {appointmentsInfoDetails?.user
                    ? appointmentsInfoDetails?.user?.email
                    : "-"}
                </div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.Rating")}
                  required={false}
                />
                <Rate
                  disabled
                  allowHalf
                  value={appointmentsInfoDetails?.rating}
                />
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.Review")}
                  required={false}
                />
                <div>{appointmentsInfoDetails?.review}</div>
              </Col>

              <Col span={8}>
                <RequiredLabel
                  text={t("Modules.Appointments.orderNumber")}
                  required={false}
                />
                <div>{appointmentsInfoDetails?.order_number}</div>
              </Col>

              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.isRecommended")}
                  required={false}
                />
                <div>
                  {appointmentsInfoDetails?.is_recommended ? "Yes" : "No"}
                </div>
              </Col>

              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.SuperAdminReview")}
                  required={false}
                />
                <div>{appointmentsInfoDetails?.super_admin_review || "-"}</div>
              </Col>
              <Col span={8}>
                <RequiredLabel
                  text={t("CommonUtils.yourReply")}
                  required={false}
                />
                <div>
                  {appointmentsInfoDetails?.organization_admin_review || "-"}
                </div>
              </Col>

              {appointmentsInfoDetails?.booking_for === "other" && (
                <Col span={24}>
                  <Flex vertical gap="1rem">
                    <Typography.Title level={3}>
                      Booking For Details :
                    </Typography.Title>
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <RequiredLabel text="Name" required={false} />
                        <div>{`${appointmentsInfoDetails?.booking_for_details?.first_name} ${appointmentsInfoDetails?.booking_for_details?.last_name}`}</div>
                      </Col>
                      <Col span={8}>
                        <RequiredLabel text="Email" required={false} />
                        <div>
                          {appointmentsInfoDetails?.booking_for_details?.email}
                        </div>
                      </Col>
                      <Col span={8}>
                        <RequiredLabel text="Relationship" required={false} />
                        <div>
                          {
                            appointmentsInfoDetails?.booking_for_details
                              ?.relationship
                          }
                        </div>
                      </Col>
                    </Row>
                  </Flex>
                </Col>
              )}
            </Row>
          </Flex>
        </GetCardLayout>

        {appointmentsInfoDetails?.service_id &&
          appointmentsInfoDetails?.service_id !== null &&
          appointmentsInfoDetails?.service_id !== undefined && (
            <GetCardLayout>
              <Flex vertical gap="2rem">
                <Typography.Title underline level={2}>
                  {t("CommonUtils.serviceInfo")}
                </Typography.Title>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.service")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_id
                        ? appointmentsInfoDetails?.service_id?.title
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.category")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_id
                        ? appointmentsInfoDetails?.service_id?.categoryInfo
                            ?.categoryName
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.subCategory")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_id
                        ? appointmentsInfoDetails?.service_id?.categoryInfo
                            ?.subcategory
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.price")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_id
                        ? appointmentsInfoDetails?.service_id?.price
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.availability")}
                      required={false}
                    />
                    <div>
                      <ol>
                        {appointmentsInfoDetails?.service_id &&
                          appointmentsInfoDetails?.service_id?.availability?.map(
                            (element) => {
                              return (
                                <li>{`${element.day} - ${element.startTime} to ${element.endTime}`}</li>
                              );
                            }
                          )}
                      </ol>
                    </div>
                  </Col>
                </Row>
              </Flex>
            </GetCardLayout>
          )}

        {userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN &&
          appointmentsInfoDetails?.service_provider_id &&
          appointmentsInfoDetails?.service_provider_id !== null &&
          appointmentsInfoDetails?.service_provider_id !== undefined && (
            <GetCardLayout>
              <Flex vertical gap="2rem">
                <Typography.Title underline level={2}>
                  {t("CommonUtils.staffInfo")}
                </Typography.Title>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.profileImage")}
                      required={false}
                    />
                    {appointmentsInfoDetails?.service_provider
                      ?.profile_image ? (
                      <Image
                        style={{
                          width: "120px",
                          maxWidth: "100%",
                          border: "1px solid lightGray",
                          padding: "5px",
                          borderRadius: "10px",
                        }}
                        src={
                          appointmentsInfoDetails?.service_provider
                            ?.profile_image
                        }
                        alt={t("CommonUtils.profileImageAlt")}
                      />
                    ) : (
                      <>-</>
                    )}
                  </Col>

                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.staffName")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider
                        ? `${appointmentsInfoDetails?.service_provider?.first_name} ${appointmentsInfoDetails?.service_provider?.last_name}`
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.email")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider
                        ? appointmentsInfoDetails?.service_provider?.email
                        : "-"}
                    </div>
                  </Col>
                  <Col span={8}>
                    <RequiredLabel
                      text={t("CommonUtils.phoneNumber")}
                      required={false}
                    />
                    <div>
                      {appointmentsInfoDetails?.service_provider
                        ? `+${appointmentsInfoDetails?.service_provider?.phone?.country_code}-${appointmentsInfoDetails?.service_provider?.phone?.phone_number}`
                        : "-"}
                    </div>
                  </Col>
                </Row>
              </Flex>
            </GetCardLayout>
          )}
      </Flex>
    </div>
  );
};

export default ServiceProviderReviewInfoDetails;
